/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const storeWhatsAppTemplateDataCategorySchema = z.enum(['AUTHENTICATION', 'UTILITY', 'MARKETING'])

export type StoreWhatsAppTemplateDataCategorySchema = z.infer<typeof storeWhatsAppTemplateDataCategorySchema>
